<template>
  <div class="login-bg">
    <div class="logo"></div>
    <div class="title">为实体门店赋能，为中小品牌发声</div>
    <div class="login-box">
      <el-form ref="form" :model="form" :rules='rules' v-if="!isSuccess">
        <div class="login-title">重设密码</div>
        <el-form-item prop="validatePhone">
          <el-input
            autocomplete="off"
            v-model="form.validatePhone"
            prefix-icon="el-icon-phone"
            placeholder="手机号"
            :maxlength="11"
            @input="changeNumber"
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="validateCode">
          <div class="velidateArea">
            <el-input
              v-model="form.validateCode"
              prefix-icon="el-icon-lollipop"
              @change="checkVerCode"
              placeholder="请输入验证码"
            ></el-input>
            <div
              :class="isHasPhone ? 'velidateCode codeChangeStyle' : 'velidateCode'"
              v-if="!isSendCode"
              @click="sendVerCode"
            >
              发送验证码
            </div>
            <div class="velidateCode" v-else>{{ wait }}秒</div>
          </div>
        </el-form-item>
        <el-form-item prop="pwd">
          <el-input
            readonly
            onfocus="this.removeAttribute('readonly') "
            autocomplete="off"
            type="password"
            v-model="firstPwd"
            prefix-icon="el-icon-lock"
            placeholder="密码"
          ></el-input>
        </el-form-item>
        <el-form-item prop="pwd">
          <el-input
            readonly
            onfocus="this.removeAttribute('readonly') "
            autocomplete="off"
            type="password"
            v-model="form.pwd"
            prefix-icon="el-icon-lock"
            placeholder="确认密码"
          ></el-input>
        </el-form-item>
        <el-form-item class="rember-pwd">
          <el-button
            type="primary"
            @click="puzzleValidate"
            class="login-btn"
            >提交</el-button
          >
        </el-form-item>
       <el-form-item label=''>
            <router-link
              to="/email/changePwd"
            >
              <div class="forgetPassword">邮箱找回?</div>
            </router-link>
          </el-form-item>
      </el-form>
      <div class="successArea" v-else>
            <div class="circle"><i class="el-icon-check"></i></div>
            <div class="login-txt">密码重设成功</div>
        </div>
      <div class="regist">
        返回<span
          style="color: #458cff; cursor: pointer"
          @click="$router.push('/')"
          >登录</span
        >
      </div>

    </div>

    <m-footer></m-footer>
  </div>
</template>
<script>
import api from "@/config/api";
import footer from "@/components/business/footer";

export default {
  components: {
    mFooter: footer,
  },
  data() {
    return {
      form: {
        validatePhone: "",
        validateCode: "",
        pwd: "",
      },
      rules: {
        validatePhone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
        ],
        validateCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
      },
      isHasPhone: false,
      isSendCode: false,
      wait: 60,
      firstPwd:'',
      isSuccess:false,
    };
  },
  created() {

  },
  methods: {
    // 倒计时
    timer() {
      if (this.wait == 0) {
        this.isSendCode = false;
        this.wait = 0;
      } else {
        this.isSendCode = true;
        this.wait--;
        setTimeout(() => {
          this.timer();
        }, 1000);
      }
    },
    // 发送验证码
    sendVerCode() {
      if (
        this.form.validatePhone &&
        /^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.form.validatePhone)
      ) {
        this.$axios
          .fetchPost(
            api.getResetPassword + "?phone=" + this.form.validatePhone,
            {}
          )
          .then((res) => {
            if (res.code === 200) {
              this.wait = 60;
              this.timer();
            } else {
              this.$message.error("短信发送失败:" + res.errorMsg);
            }
          });
      }
    },
    // 输入手机号
    changeNumber(val){
      if(val.length==11){
        this.inputPhoneNumber()
      }else{
        this.isHasPhone = false;
      }
    },
    // 验证手机号码
    inputPhoneNumber() {
      if (/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.form.validatePhone)) {
        this.isHasPhone = true;
      } else {
        this.isHasPhone = false;
        this.$message({
          message: "请输入正确的手机号",
          type: "error",
        });
      }
    },
    //验证码校验
    checkVerCode(){
      this.inputPhoneNumber()
      if(this.isHasPhone){
        this.$axios
          .fetchPost(
            api.checkVerCode + "?phone=" + this.form.validatePhone + '&validateCode='+this.form.validateCode,
            {}
          )
          .then((res) => {
            if (res.code === 200) {
              if (!res.data) {
                this.registFormOneData.validateCode = "";
                this.$message({
                  message: "请输入正确验证码",
                  type: "error",
                });
              }
            } else {
              this.$message.error("发送异常");
            }
          });
      }
    },
    // 提交
    puzzleValidate() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if(!this.form.pwd){
            this.$message({
            message: "请输入新密码！",
            type: "error",
          })
          }else if(this.firstPwd != this.form.pwd){
            this.$message({
            message: "两次输入的密码不一致！",
            type: "error",
          })
          }else{
          this.updatePwd();
          }
        } else {
          if (!this.form.validatePhone || !this.form.validateCode) {
          this.$message({
            message: "请输入手机号和验证码！",
            type: "error",
          });
          return;
        }
        }
      });
    },
    // 修改密码
    updatePwd() {
      this.$axios
          .fetchPost(
            api.phoneResetPassword + "?phone=" + this.form.validatePhone + '&verification='+this.form.validateCode + "&nowPassword=" + this.$utils.md5(this.form.pwd),
            {}
          )
          .then((res) => {
            if (res.code === 200) {
              this.isSuccess = true
            } else {
              this.$message.error("修改失败");
            }
          });
    },
  },
};
</script>
<style>
.login-bg {
  width: 100%;
  height: 100%;
  min-height: 700px;
  min-width: 1200px;
  background-image: url("../assets/images/login-bg2.png");
  background-size: 100% 100%;
}
.login-bg .regist {
  color: #fff;
  text-align: center;
}
.login-bg .rember-pwd {
  min-height: unset;
}
.login-bg .login-box {
  width: 30vw;
  position: absolute;
  top: 25vh;
  left: 35vw;
  padding: 20px;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

.login-bg .title {
  font-size: 20px;
  color: #fff;
  text-align: center;
  position: absolute;
  width: 100%;
  text-align: center;
  top: calc(25vh - 40px);
}

.login-bg .logo {
  position: absolute;
  left: calc(50vw - 108px);
  top: calc(25vh - 100px);
  width: 180px;
  height: 35px;
  background-image: url(../assets/images/logo.png);
  background-size: 100% 100%;
}

.login-bg .el-form-item__content {
  width: 90%;
  margin: 0 auto;
  line-height: 40px;
}

.login-bg .el-input--prefix .el-input__inner {
  padding-left: 40px;
}

.login-bg .el-form-item__content .el-input__inner {
  background-color: transparent;
  border: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  height: 45px;
  box-sizing: border-box;
  border-radius: 4px;
}

.login-bg .login-btn {
  width: 100%;
  border-radius: 5px;
  border: 0px;
  height: 40px;
  font-weight: bolder;
  letter-spacing: 5px;
}

.login-bg .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #fff;
}

.login-bg .el-checkbox .el-checkbox__inner {
  border-color: #fff;
  background-color: transparent;
}
.login-bg .el-tabs__nav-wrap::after {
  display: none;
}
.login-bg .el-tabs__item {
  color: #fff;
  padding-left: 0;
}
.login-bg .el-checkbox__inner::after {
  border-color: #409eff;
}
.login-bg .el-tabs__active-bar {
  bottom: 5px;
  width: 34px !important;
  left: 10px;
}
.login-bg .el-tabs__item.is-active,
.login-bg .el-tabs__item:hover {
  color: #409eff;
  border: 0;
}

.login-bg .el-checkbox .el-checkbox__label {
  color: #fff;
  font-size: 12px;
}

.login-bg .el-input__icon {
  line-height: 47px;
  font-size: 22px;
}

.login-bg .el-input {
  width: 100%;
  margin-bottom: 20px;
  height: 100%;
}

.check-item {
  text-align: right;
  margin-top: -10px;
}
.login-bg .rember-password {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.login-bg a {
  color: #fff;
  font-size: 12px;
}
.login-title {
  color: #fff;
  text-align: center;
  padding-bottom: 20px;
  font-size: 18px;
}
.velidateArea {
  display: flex;
  justify-content: space-between;
}
.velidateCode {
  display: inline-block;
  height: 45px;
  line-height: 45px;
  width: 26%;
  vertical-align: bottom;
  text-align: center;
  margin-left: 10px;
  background-color: #f2f2f2;
  border-radius: 4px;
  color: #999;
}
.codeChangeStyle {
  cursor: pointer;
  color: #000;
}
.forgetPassword {
  color: #458cff;
  cursor: pointer;
}
.successArea {
  height: 200px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
}

.successArea .circle {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 1px solid #458cff;
  background-color: #458cff;
  margin-bottom: 10px;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  font-size: 48px;
  color: #fff;
}
.successArea .login-txt{
  font-size: 18px;
  color: #fff;
}
</style>




// WEBPACK FOOTER //
// src/page/PhoneChangePwd.vue